<div class="file">
  <div class="infos">
    <div class="left-part">
      <i class="fal" aria-hidden="true" [ngClass]="file.icon"></i>
      <span> {{ file.name }}</span>
    </div>
    <div class="right-part">
      @if (canRemove) {
        <i class="fal fa-times" aria-hidden="true" (click)="removeFile()"></i>
      }
    </div>
  </div>
  <div class="progress">
    <div [style.width.%]="swpercent" [ngClass]="status"></div>
  </div>
</div>
